
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";

interface ActionButtonProps {
  onClick: () => void;
  text: string;
}

const ActionButton = ({ onClick, text }: ActionButtonProps) => {
  return (
    <Button 
      onClick={onClick}
      className="bg-white/10 hover:bg-white/20 text-white border-2 border-[#ECA505] px-4 py-1.5 rounded-lg text-sm font-semibold flex items-center gap-2 transition-all cursor-pointer"
    >
      {text} <div className="flex items-center">
        <ChevronRight className="w-4 h-4" />
        <ChevronRight className="w-4 h-4 -ml-2" />
      </div>
    </Button>
  );
};

export default ActionButton;
